import script from "./PageMessage.vue?vue&type=script&setup=true&lang=ts"
export * from "./PageMessage.vue?vue&type=script&setup=true&lang=ts"

import "./PageMessage.vue?vue&type=style&index=0&id=6dee68e1&lang=scss"

const __exports__ = script;

export default __exports__